import styled from 'styled-components';
import ProductImageComponent from '../common/ProductImage';
import restaurantConfig from '../../config/restaurantConfig';

export const MainContentLayout = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 30px;

    @media (max-width: 992px) {
        flex-direction: column;
    }
`;

export const LeftColumn = styled.div`
    flex: 0 0 350px;
    display: flex;
    flex-direction: column;

    @media (max-width: 992px) {
        flex: 0 0 auto;
        width: 100%;
    }
`;

export const ImageContainer = styled.div`
    width: 100%;
    height: 350px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;

    @media (max-width: 992px) {
        height: 300px;
    }

    @media (max-width: 480px) {
        height: 250px;
    }
`;

export const RightColumn = styled.div`
    flex: 1;
    overflow-y: visible;
    overflow-x: hidden;
    border-left: 1px solid #eee;
    padding-left: 20px;
    position: relative;

    @media (max-width: 992px) {
        border-left: none;
        padding-left: 0;
        border-top: 1px solid #eee;
        padding-top: 20px;
    }
`;

export const ProductImg = styled(ProductImageComponent)`
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    border: 3px solid white;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);

    img {
        object-fit: cover;
    }
`;

export const BadgeContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 15px;
`;

export const ComboSummaryCard = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(247, 249, 252, 0.96) 0%, rgba(255, 255, 255, 1) 100%);
    box-shadow: 0 10px 25px rgba(15, 23, 42, 0.05);
    padding: 1rem;
    margin-bottom: 1.25rem;
`;

export const ComboSummaryHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.85rem;
`;

export const ComboSummaryTitle = styled.h3`
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
    color: #1f2937;
`;

export const ComboSummaryHint = styled.p`
    margin: 0.2rem 0 0;
    font-size: 0.85rem;
    color: #6b7280;
    line-height: 1.4;
`;

export const ComboSummaryList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
`;

export const ComboSummaryRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.75rem 0.85rem;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #edf2f7;
`;

export const ComboSummaryRowLeft = styled.div`
    min-width: 0;
    flex: 1;
`;

export const ComboSummaryName = styled.div`
    font-weight: 700;
    color: #1f2937;
    font-size: 0.95rem;
    line-height: 1.3;
`;

export const ComboSummaryMeta = styled.div`
    margin-top: 0.2rem;
    color: #6b7280;
    font-size: 0.8rem;
    line-height: 1.3;
`;

export const ComboSummaryQty = styled.div<{ accent?: string }>`
    flex-shrink: 0;
    min-width: 52px;
    text-align: center;
    padding: 0.45rem 0.65rem;
    border-radius: 12px;
    background: ${props => props.accent ? `${props.accent}12` : '#f7f9fc'};
    color: ${props => props.accent || '#1f2937'};
    font-weight: 800;
    font-size: 0.9rem;
    border: 1px solid ${props => props.accent ? `${props.accent}22` : '#edf2f7'};
`;

export const ComboSummaryEmpty = styled.div`
    padding: 0.85rem 1rem;
    border-radius: 12px;
    background: #f8fafc;
    border: 1px dashed #dbe3ee;
    color: #6b7280;
    font-size: 0.9rem;
    line-height: 1.4;
`;

export const DietaryBadge = styled.span<{ type?: string }>`
    background-color: ${props => {
        switch (props.type?.toLowerCase()) {
            case 'vegano': 
            case 'vegan': return '#48bb78';
            case 'vegetariano': 
            case 'vegetarian': return '#68d391';
            case 'sem glúten': 
            case 'gluten_free': return '#f6ad55';
            case 'sem lactose': 
            case 'lactose_free': return '#63b3ed';
            default: return '#e2e8f0';
        }
    }};
    color: white;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 50px;
    text-transform: uppercase;
`;

export const ProductDescription = styled.div<{ isExpanded?: boolean }>`
    color: #666;
    margin-bottom: 10px;
    font-size: 0.95rem;
    line-height: 1.5;
`;

export const ShowMoreButton = styled.button`
    background: none;
    border: none;
    color: ${props => props.theme.primary || restaurantConfig.theme.primary};
    font-size: 0.85rem;
    font-weight: 600;
    padding: 0;
    margin-bottom: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        text-decoration: underline;
    }
`;

export const ExtraGroup = styled.div`
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;

    &:last-child {
        border-bottom: none;
    }
`;

export const ExtraGroupHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f7f9fc;
    padding: 12px 15px;
    margin: 0 -20px 15px -20px;
    border-bottom: 1px solid #edf2f7;

    @media (max-width: 992px) {
        margin-left: -15px;
        margin-right: -15px;
    }
`;

export const ExtraGroupTitle = styled.h3`
    margin: 0;
    font-size: 1.1rem;
    color: #2d3748;
    font-weight: 700;
`;

export const RequiredBadge = styled.span`
    background-color: #2d3748;
    color: white;
    font-size: 0.65rem;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const ExtraOption = styled.div<{ selected: boolean; available: boolean }>`
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #edf2f7;
    cursor: ${props => props.available ? 'pointer' : 'not-allowed'};
    opacity: ${props => props.available ? 1 : 0.6};

    &:last-child {
        border-bottom: none;
    }
`;

export const ExtraOptionContent = styled.div`
    display: flex;
    align-items: center;
    gap: 0.85rem;
    min-width: 0;
    flex: 1;
`;

export const ExtraOptionImageWrap = styled.div`
    width: 56px;
    height: 56px;
    min-width: 56px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
`;

export const NotesTextarea = styled.textarea`
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    min-height: 100px;
    font-family: inherit;
    font-size: 1rem;
    resize: vertical;

    &:focus {
        outline: none;
        border-color: ${props => props.theme.primary || restaurantConfig.theme.primary};
    }
`;

export const MobileNotesSection = styled.div`
    display: none;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;

    @media (max-width: 992px) {
        display: block;
    }
`;

export const DesktopNotesSection = styled.div`
    display: block;
    margin-top: 20px;

    @media (max-width: 992px) {
        display: none;
    }
`;

export const OptionPrice = styled.div`
    font-size: 0.875rem;
    font-weight: 700;
    margin-top: 0.25rem;
    color: ${props => props.theme.primary || '#e74c3c'};
`;

export const RadioIcon = styled.i<{ selected: boolean }>`
    font-size: 1.5rem;
    color: ${props => props.selected ? (props.theme.primary || '#e74c3c') : '#cbd5e0'};
`;

export const AddToCartButton = styled.button`
    background-color: ${props => props.theme.primary || '#e74c3c'};
    color: white;
    border: none;
    border-radius: 12px;
    padding: 0.8rem 1.2rem;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 4px 6px ${props => props.theme.primary ? `${props.theme.primary}33` : 'rgba(0, 0, 0, 0.1)'};
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    gap: 0.5rem;
    min-width: 0;

    &:hover:not(:disabled) {
        filter: brightness(0.9);
        transform: translateY(-1px);
        box-shadow: 0 6px 12px ${props => props.theme.primary ? `${props.theme.primary}4D` : 'rgba(0, 0, 0, 0.15)'};
    }

    &:disabled {
        background-color: #cbd5e0;
        cursor: not-allowed;
    }

    span:first-child {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        text-align: left;
    }

    @media (max-width: 480px) {
        padding: 0.8rem 1rem;
        font-size: 0.95rem;
        flex: 1;
        min-width: 0;
    }
`;
